import React from "react";
import { useFieldArray, useWatch } from "react-hook-form";
import {
  StyledWrapper,
  StyledControls,
} from "./contestPermissionsFields.style";
import ContestPermission from "./contestPermission.component";

const ContestPermissionsFields = ({ name, settings = {} }) => {
  const { append, fields } = useFieldArray({ name, keyName: "_id" });
  const watchArray = useWatch({ name });
  const lastVisibleIndex = watchArray.findLastIndex((item) => !item._destroy);

  const handleAddField = (e) => {
    e.preventDefault();
    append({
      _destroy: settings._destroy.default,
      category: settings.category.default,
      permission_type: settings.permission_type.default,
      criteria: settings.criteria.default,
    });
  };
  return (
    <StyledWrapper>
      {fields.map((field, index) => (
        <ContestPermission
          key={field._id}
          index={index}
          parentName={name}
          settings={settings}
          values={field}
          lastVisibleIndex={lastVisibleIndex}
          append={append}
        />
      ))}
      {lastVisibleIndex === -1 && (
        <StyledControls>
          <a href="#" onClick={handleAddField}>
            + Add criteria
          </a>
        </StyledControls>
      )}
    </StyledWrapper>
  );
};

export default ContestPermissionsFields;
